import register from '../../../../global/js/registry';
export default register('m-form', () => import(/* webpackMode: "lazy" */ './m-form.controller'));
